import { FeatureFlagContractService } from "./feature-flag.contract.service";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagOfflineService implements FeatureFlagContractService {
  fetchAndUpdate(): void {
      console.log("Not implemented");
  }
  isFlagEnabled(flagName: string): boolean {
    return false;
  }

}
